import { useAppSelector } from '@/hooks/useAppSelector';
import type { PortalCode } from '@/types/identity';
import { CustomerPortalSections } from './sections/CustomerPortalSections';
import { VendorPortalSections } from './sections/VendorPortalSections';
import { EmployeePortalSections } from './sections/EmployeePortalSections';
import { CandidatePortalSections } from './sections/CandidatePortalSections';
import { DeliveryPortalSections } from './sections/DeliveryPortalSections';
import { PortalDataList } from './sections/PortalDataList';

export function PortalSectionRouter() {
  const session = useAppSelector((s) => s.identity.session);
  if (!session) return null;

  const portal = session.activePortalCode as PortalCode;
  switch (portal) {
    case 'CUSTOMER':
      return <CustomerPortalSections />;
    case 'VENDOR':
      return <VendorPortalSections />;
    case 'EMPLOYEE':
      return <EmployeePortalSections />;
    case 'CANDIDATE':
      return <CandidatePortalSections />;
    case 'DELIVERY':
      return <DeliveryPortalSections />;
    case 'PARTNER':
      return (
        <PortalDataList
          title="Partner workspace"
          description="Collaboration and documents"
          items={[]}
          emptyMessage="Partner portal content loads here."
        />
      );
    default:
      return null;
  }
}
